/**
 * CategoryPageV2 — redesigned shell for the Categories list.
 *
 * Mirrors the prototype's `.screen-categories` layout: PageHeader on top,
 * then three lib-sections (Audio / Quick Tap / Audiobook) below.
 *
 * Total chip in the header reads "N total · M active" so admins can scan
 * health at a glance without expanding any section.
 */
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import CategoriesTableV2 from '../../CategoriesTable/v2/CategoriesTableV2';
import { PageHeader, Button } from '../../redesign';

const PlusSign = (
  <span style={{ fontSize: 16, lineHeight: 1 }} aria-hidden>+</span>
);

export default function CategoryPageV2() {
  const allCategories = useSelector((s) => s.categories.all_categories);

  // "32 total · 28 active" — derive from the same Redux slice the table
  // reads, excluding audiobook categories so the chip matches the list
  // below (v1 parity: audiobooks are managed under the Audiobooks page).
  const totalLabel = useMemo(() => {
    if (!allCategories) return undefined;
    const visible = allCategories.filter((c) => !c.category_is_audiobook);
    const total   = visible.length;
    const active  = visible.filter((c) => c.category_is_active).length;
    return `${total.toLocaleString()} total · ${active.toLocaleString()} active`;
  }, [allCategories]);

  return (
    <div className="bg-bg min-h-full">
      <PageHeader
        eyebrow="Content Library"
        title="Categories"
        total={totalLabel}
        actions={
          <Link to="/category/add" className="no-underline">
            <Button variant="coral" leadingIcon={PlusSign}>New category</Button>
          </Link>
        }
      />
      <CategoriesTableV2 />
    </div>
  );
}
